/**
 * Gibbs Knowledge — disease → drug target lookups, matching,
 * and the abstract-goal clarification cascade.
 *
 * @module gibbs/knowledge
 */

export { diseaseTargets } from './diseaseTargets';
export { matchDisease, matchDesignGoalForDisease } from './diseaseMatcher';
export {
    buildDiseaseTargetClarification,
    buildWorkflowForSelectedTarget,
    buildWorkflowForStructureSource,
} from './diseaseCascade';
export {
    matchDockAndScoreIntent,
    buildDockAndScoreWorkflow,
    workspaceHasLoadedProtein,
    workspaceHasLoadedCompound,
    workspaceHasBindingSite,
    tryDockAndScoreShortcut,
} from './dockAndScoreShortcut';

export {
    matchInteractionViewIntent,
    buildInteractionViewSetup,
} from './interactionViewShortcut';
export {
    matchFragmentGrowIntent,
    checkFragmentGrowPreconditions,
} from './fragmentGrowShortcut';
export {
    matchCompoundDataIntent,
    buildCompoundSummary,
    parseFilterExpression,
    applyFilter,
} from './compoundDataShortcut';

export {
    matchTelemetryIntent,
    formatTelemetryLog,
} from './telemetryShortcut';

export {
    matchHitDiscoveryIntent,
    tryHitDiscoveryShortcut,
    buildFragmentHitDiscoveryWorkflow,
} from './hitDiscoveryShortcut';
export { suggestNextStep } from './nextStepSuggester';
export {
    matchComparisonIntent,
    parseComparisonIndices,
    buildComparison,
} from './compoundComparisonShortcut';

export {
    matchVirtualScreeningIntent,
    tryVirtualScreeningShortcut,
    buildVirtualScreeningWorkflow,
} from './virtualScreeningShortcut';

export {
    matchDeNovoIntent,
    tryDeNovoShortcut,
    buildDeNovoWorkflow,
} from './deNovoGenerationShortcut';

export {
    CAMPAIGN_VERB_CATALOG,
    matchCampaignIntent,
    tryCampaignShortcut,
} from './campaignShortcut';

export {
    matchWorkflowTemplateIntent,
    detectTemplateAlias,
    buildPlanFromTemplate,
    tryWorkflowTemplateShortcut,
    getKnownTemplateIds,
} from './workflowTemplateShortcut';

export {
    ALL_MEDCHEM_RULES,
    ISOSTERE_RULES,
    FLUORINE_RULES,
    HETEROAROMATIC_RULES,
    TOXICOPHORE_RULES,
    SULFUR_INTERACTION_RULES,
    INTERACTION_TUNING_RULES,
    getRulesByCategory,
    findRelevantRules,
    formatRulesForPrompt,
    formatRuleShort,
    formatRuleShortForCompound,
    getApplicableMitigations,
} from './medchemRules';
export {
    matchMedchemAdviceIntent,
    buildMedchemAdvice,
    tryMedchemAdviceShortcut,
    matchScanAlertsIntent,
} from './medchemAdviceShortcut';
export {
    scanSmilesForAlerts,
    scanCompoundsForAlerts,
    formatAlertSummary,
} from './structuralAlertScanner';

export {
    AMBIGUITY_RULES,
    detectChemistryAmbiguity,
    buildChemistryClarification,
    rewriteWithDisambiguation,
} from './chemistryDisambiguation';

export {
    resolveMitigationHighlight,
    listSupportedMitigationVisuals,
} from './mitigationHighlightResolver';
